import React from 'react';
import PropTypes from 'prop-types';
import { StyledModalActions } from './ModalAction.styled';
function ModalActions(_ref) {
  var align = _ref.align,
    children = _ref.children,
    elevate = _ref.elevate,
    gutter = _ref.gutter;
  return /*#__PURE__*/React.createElement(StyledModalActions, {
    align: align,
    elevate: elevate,
    gutter: gutter
  }, children);
}
ModalActions.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Alignment of contents
   */
  align: PropTypes.oneOf(['flex-start', 'center', 'flex-end']),
  /**
   * Contents to display inside dialog
   */
  children: PropTypes.node.isRequired,
  /**
   * If `true`, adds box shadow
   */
  elevate: PropTypes.bool,
  /**
   * If `false`, the actions do not have additional margin.
   */
  gutter: PropTypes.bool
} : {};
ModalActions.defaultProps = {
  align: 'flex-end',
  elevate: true,
  gutter: true
};
export default ModalActions;